module.exports = __webpack_public_path__ + "img/39.64a34b91.jpg";